import styled from '@emotion/styled';
import { NewTRow } from 'components/Kizen/Table';
import BaseErrorCard from 'components/Kizen/ErrorCard';

export const TRow = styled(NewTRow)`
  &&:hover {
    background-color: var(--color-background-white);
  }
`;

export const ErrorCard = styled(BaseErrorCard)`
  margin-top: -8px;
`;
